// 4.排序方法
export function SortFun(attr, rev) {
  //第一个参数传入info里的prop表示排的是哪一列，第二个参数是升还是降排序
  console.log(attr, rev)
  if (rev === undefined) {
    rev = 1
  } else {
    rev = rev ? 1 : -1
  }
  return function(a, b) {
    a = a[attr]
    b = b[attr]
    if (a != null) {
      // 1.列数据类型为string时的排序
      if (typeof a == 'string') {
        // 1.1 判断是否为日期类型
        if (a.split(' ').length === 2) {
          if (a < b) {
            return rev * -1
          }
          if (a > b) {
            return rev * 1
          }
          return 0
        } else if (!isNaN(a)) {
          // 是否能转为数字类型
          if (parseFloat(a) < parseFloat(b)) {
            return rev * -1
          }
          if (a > b) {
            return rev * 1
          }
          return 0
        } else {
          // 1.2 普通字符类型
          if (a < b) {
            return rev * -1
          }
          if (a > b) {
            return rev * 1
          }
          return 0
        }
      }
      // 2. 列数据类型为number时的排序
      if (typeof a == 'number') {
        if (a < b) {
          return rev * -1
        }
        if (a > b) {
          return rev * 1
        }
        return 0
      }
    }
  }
}
